import react from "react";
import { Text,View } from "react-native";
const ProductDetail=props=>{
    return(
        <View>
            <Text>{props.route.params.product.title}</Text>
        </View>
    )
}

export default ProductDetail;